import type { FieldPresentationBlock } from '#layers/data-model/constants/fields';

interface FieldInputMetaOptions {
	typeOptions?: Record<string, unknown> | null;
	inputOptions?: Record<string, unknown> | null;
}

interface FieldInputMeta extends FieldInputMetaOptions {
	inputId?: string | null;
}

/** Merge field type and input options in the same order used for rendered input blocks. */
export function getFieldInputMetaProps(meta: FieldInputMetaOptions): Record<string, unknown> {
	return {
		...meta.typeOptions,
		...meta.inputOptions,
	};
}

/** Resolve an explicit block override against defaults without leaking default props to custom blocks. */
export function resolveFieldPresentationBlock(
	defaults: FieldPresentationBlock,
	blockOverride?: string | null,
	props?: Record<string, unknown> | null,
): FieldPresentationBlock {
	const block = blockOverride ?? defaults.block;
	const defaultProps = block === defaults.block ? defaults.props : undefined;
	const resolvedProps = { ...defaultProps, ...props };

	return {
		block,
		...(Object.keys(resolvedProps).length > 0 ? { props: resolvedProps } : {}),
	};
}

/** Resolve field input metadata against a default input presentation. */
export function resolveFieldInputPresentation(
	defaults: FieldPresentationBlock,
	meta?: FieldInputMeta | null,
): FieldPresentationBlock {
	return resolveFieldPresentationBlock(
		defaults,
		meta?.inputId,
		getFieldInputMetaProps({
			typeOptions: meta?.typeOptions,
			inputOptions: meta?.inputOptions,
		}),
	);
}
